<template>
  <div class="staticBanner">
    <div class="imgsize">
      <!-- <img  src="../../../assets/images/staticBanner/08-01.png" alt="" /> -->
      <img :src="bannerDate.url" class="multimedia" alt="">
    </div>
    <div class="staticimg ">
      <h4 class="staticimg-title" :class="isBlack ? 'color-extra05' : 'color-white'" v-html="bannerDate.title"></h4>
      <p class="staticimg-content" :class="isBlack ? 'color-extra06' : 'color-white'" v-html="bannerDate.content" :style="{  maxWidth: bannerDate.contentWidth }"></p>
      <!-- <div class="staticimg-btn" v-if="bannerDate.btn">了解更多</div> -->
      <button type="button" class="btn btn-outline-primary text-white staticimg-btn" v-if="bannerDate.btn" @click="goUs()">了解更多</button>
      <button type="button" class="btn btn-outline-primary text-white staticimg-btn" v-if="bannerDate.btns" @click="goCall()">立即咨询</button>
    </div>
  </div>
</template>
<script>
export default {
  name: "StaticBanner",
  props: {
    bannerDate:{},
    isBlack: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    }
  },
  methods:{
    goUs(){
      this.$router.push({
        path:"/about-us"
      })
    },
    goCall(){
      this.$router.push({
        path:"/call-us"
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.color-extra05 {
  color: var(--color-extra05);
}
.color-extra06 {
  color: var(--color-extra06);
}
.staticimg-title {
  line-height: 1.5;
}
.staticBanner {
  position: relative;
  max-width: 1920px;
  /*.imgsize{
    img{
      display: block;
      width: 100%;
      min-width: 500px;
      max-height: 600px;
      
    }
  }
  .staticimg {
    position: absolute;
    top: 33%;
    left: 13%;
    margin-right: 13%;
    .staticimg-btn{
      width: 12rem;
      height: 4rem;
      font-size: 12px;
      border-color: #fff ;
      margin-top: 15px;
    }
  }*/
}
</style>
